import { render, staticRenderFns } from "./RTabs.vue?vue&type=template&id=109e77ca&scoped=true&"
import script from "./RTabs.vue?vue&type=script&lang=js&"
export * from "./RTabs.vue?vue&type=script&lang=js&"
import style0 from "./RTabs.vue?vue&type=style&index=0&id=109e77ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109e77ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab,VTabs})
